var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { Typography } from "@mui/material";
export const QuestionName = (_a) => {
    var { question } = _a, props = __rest(_a, ["question"]);
    return (_createElement(Typography, Object.assign({}, props, { key: `qtitle|${question.QuestionSKU}` }), question.QuestionName));
};
